import { Type } from 'class-transformer';
import type dayjs from 'dayjs';
import { IntegrationModel } from './integration_model';
import { LinkedModelSync } from './linked_model_sync';
import { Model } from './model';
import { UnifiedModel } from './unified_model';
import { TransformStringToDayJS } from './utils';

export type LinkedModelScope = 'Disabled' | 'Read' | 'Write' | 'R + W';

export enum LinkedModelHealthStatus {
  INCOMPLETE = 'incomplete',
  UNHEALTHY = 'unhealthy',
  HEALTHY = 'healthy',
}

export type LinkedModelHealthStatusReason =
  | 'incomplete_field_mappings'
  | 'missing_permission'
  | 'unknown';

export class LinkedModelHealth {
  status: LinkedModelHealthStatus;

  details: Record<string, any> | null;

  message: string | null;

  reason: LinkedModelHealthStatusReason | null;
}

export class LinkedModel extends Model {
  id: string;

  name: string;

  @Type(() => LinkedModelHealth)
  health: LinkedModelHealth | null;

  @Type(() => IntegrationModel)
  integration_model: IntegrationModel;

  is_file_upload_enabled: boolean;

  is_read_enabled: boolean;

  is_write_enabled: boolean;

  is_webhooks_setup: boolean;

  @TransformStringToDayJS()
  last_sync_at: dayjs.Dayjs | null;

  @Type(() => LinkedModelSync)
  last_sync: LinkedModelSync | null;

  linked_integration_id: string;

  @Type(() => UnifiedModel)
  model: UnifiedModel;

  @TransformStringToDayJS()
  next_sync_at: dayjs.Dayjs | null;

  get displayName(): string {
    return this.name === 'Partner' ? 'Customer' : this.name;
  }

  get scope(): LinkedModelScope {
    if (this.is_write_enabled) {
      return this.is_read_enabled ? 'R + W' : 'Write';
    }

    if (this.is_read_enabled) {
      return 'Read';
    }

    return 'Disabled';
  }
}
